(() => {
  const main = document.getElementById('MainContent');
  if (!main || !document.documentElement.classList.contains('rs-page-loading')) return;
  main.inert = true;
  main.setAttribute('aria-busy', 'true');
  const images = [...main.querySelectorAll('img')].filter((img) => {
    const bounds = img.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0 && bounds.top < window.innerHeight && bounds.bottom > 0;
  }).slice(0, 4);
  const cleanup = [];
  const done = () => {
    cleanup.forEach((remove) => remove());
    window.rsFinishPageSkeleton?.();
  };
  const pending = images.map((img) => new Promise((resolve) => {
    if (img.complete) return resolve();
    const settled = () => {
      img.removeEventListener('load', settled);
      img.removeEventListener('error', settled);
      resolve();
    };
    cleanup.push(settled);
    img.addEventListener('load', settled);
    img.addEventListener('error', settled);
    if (img.complete) settled();
  }));
  Promise.all(pending).then(done);
  window.addEventListener('pageshow', (event) => { if (event.persisted) done(); });
})();
